import { render } from "./my-title.vue?vue&type=template&id=45679b0b"
import script from "./my-title.vue?vue&type=script&lang=js"
export * from "./my-title.vue?vue&type=script&lang=js"

import "./my-title.vue?vue&type=style&index=0&id=45679b0b&lang=css"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__